import { v4 as uuidv4 } from 'uuid';

export default () => {
  const uuid = uuidv4()
  return {
    valueType: 'UploadImg',
    $id: uuid,
    FormItemProps: {
      label: '图片上传',
      name: uuid,
      required: false,
    },
  }
};
